(() => {
  const SELECTOR = '[data-vella-sticky-buy]';
  const OVERLAY_SELECTOR = 'cart-drawer.active, details-modal[open], quick-add-modal[open], product-modal[open]';
  const stickyStates = new WeakMap();

  function getPrimaryButton() {
    return document.querySelector('.vella-main-product .product-form__submit');
  }

  function isOverlayOpen() {
    return Boolean(document.querySelector(OVERLAY_SELECTOR));
  }

  function scrollToBuy() {
    const button = getPrimaryButton();
    if (!button) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    button.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    window.setTimeout(() => button.focus({ preventScroll: true }), reduceMotion ? 0 : 350);
  }

  function renderVisibility(root) {
    const state = stickyStates.get(root);
    root.classList.toggle('is-visible', Boolean(state?.hasPassedPrimary && !isOverlayOpen()));
  }

  function updateStickyState(root) {
    const primary = getPrimaryButton();
    const price = document.querySelector('.vella-main-product [id^="price-"] .price-item--last');
    const priceTarget = root.querySelector('[data-vella-sticky-price]');
    const button = root.querySelector('[data-vella-scroll-to-buy]');

    if (price && priceTarget) priceTarget.textContent = price.textContent.trim();
    if (!primary || !button) return;

    const primaryLabel = primary.querySelector('span')?.textContent.trim() || primary.textContent.trim();
    button.textContent = primaryLabel;
    button.disabled = primary.disabled;
    button.setAttribute('aria-disabled', String(primary.disabled));
  }

  function observePrimary(root) {
    const state = stickyStates.get(root);
    const primary = getPrimaryButton();
    if (!state || state.primary === primary) return;

    state.observer?.disconnect();
    state.observer = null;
    state.primary = primary;
    state.hasPassedPrimary = false;

    if (!primary || !('IntersectionObserver' in window)) {
      renderVisibility(root);
      return;
    }

    state.observer = new IntersectionObserver(([entry]) => {
      state.hasPassedPrimary = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      renderVisibility(root);
    }, { threshold: 0 });
    state.observer.observe(primary);
  }

  function initSticky(root) {
    if (!root || stickyStates.has(root)) return;

    const button = root.querySelector('[data-vella-scroll-to-buy]');
    button?.addEventListener('click', scrollToBuy);
    stickyStates.set(root, {
      button,
      observer: null,
      primary: null,
      hasPassedPrimary: false,
    });

    updateStickyState(root);
    observePrimary(root);
  }

  function destroySticky(root) {
    const state = stickyStates.get(root);
    if (!state) return;

    state.observer?.disconnect();
    state.button?.removeEventListener('click', scrollToBuy);
    stickyStates.delete(root);
  }

  function rootsWithin(scope) {
    return [
      ...(scope.matches?.(SELECTOR) ? [scope] : []),
      ...scope.querySelectorAll(SELECTOR),
    ];
  }

  function refreshAll() {
    document.querySelectorAll(SELECTOR).forEach((root) => {
      initSticky(root);
      updateStickyState(root);
      observePrimary(root);
      renderVisibility(root);
    });
  }

  function start() {
    refreshAll();

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-vella-scroll-to-buy]');
      if (!trigger || trigger.closest(SELECTOR)) return;
      scrollToBuy();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => window.requestAnimationFrame(refreshAll));
    }

    const overlayObserver = new MutationObserver(() => {
      document.querySelectorAll(SELECTOR).forEach(renderVisibility);
    });
    overlayObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'open'],
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', () => window.requestAnimationFrame(refreshAll));
  document.addEventListener('shopify:section:unload', (event) => {
    rootsWithin(event.target).forEach(destroySticky);
    window.requestAnimationFrame(refreshAll);
  });
})();
